/** Dominio canónico público (SEO, hreflang, schema). */
export const SITE_ORIGIN = 'https://www.kailac.com';
